import {
  Heading,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent, ModalFooter,
  ModalHeader,
  ModalOverlay
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { NavigationTabs } from "../../../components/NavigationTabs";
import { useEffect, useState } from "react";
import { mapLocationsModalData } from "../helpers";

function PhysicalRiskLocationsModal({ modalData, isOpen, onClose }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "physicalRisk.modal"
  });
  const [locations, setLocations] = useState();

  useEffect(() => {
    if (modalData) {
      setLocations(mapLocationsModalData(modalData.physicalRiskLocations));
    } else {
      setLocations(null);
    }
  }, [modalData]);

  const onModalClose = () => {
    onClose();
  };

  return modalData && isOpen ? <Modal isOpen={isOpen} onClose={onModalClose} size="6xl">
    <ModalOverlay />
    <ModalContent>
      <ModalHeader>{modalData.supplier} {t("locations")}</ModalHeader>
      <ModalCloseButton />
      <ModalBody>
        {locations && locations.length > 0 ? <NavigationTabs
          elements={locations}
          tabTitle={"Location"}
          subTitleAttribute={"name"}
        /> : <Heading size="md" marginBlock="1">
          {t("missingLocations")}
        </Heading>}
      </ModalBody>
      <ModalFooter />
    </ModalContent>
  </Modal> : null;
}

export default PhysicalRiskLocationsModal;